import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useTranslation } from 'react-i18next';

export const FAQ = () => {
  const { t } = useTranslation();
  
  // Get FAQ data dynamically based on current language
  const faqData = [
    { id: "faq-1", question: t('faq.q1.question'), answer: t('faq.q1.answer') },
    { id: "faq-2", question: t('faq.q2.question'), answer: t('faq.q2.answer') },
    { id: "faq-3", question: t('faq.q3.question'), answer: t('faq.q3.answer') },
    { id: "faq-4", question: t('faq.q4.question'), answer: t('faq.q4.answer') },
    { id: "faq-5", question: t('faq.q5.question'), answer: t('faq.q5.answer') }
  ];
  
  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#C5A35C]/10 border border-[#C5A35C]/20 mb-6">
            <span className="text-[#C5A35C] text-sm font-semibold">{t('faq.badge')}</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('faq.description')}
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqData.map((faq) => (
            <AccordionItem 
              key={faq.id} 
              value={faq.id}
              className="border-2 border-gray-100 rounded-xl px-6 hover:border-[#C5A35C]/30 transition-all duration-300 data-[state=open]:border-[#C5A35C]/50 data-[state=open]:shadow-lg"
            >
              <AccordionTrigger className="text-left hover:text-[#C5A35C] text-lg font-semibold py-6 hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Additional Help CTA */}
        <div className="mt-12 text-center p-8 rounded-2xl bg-gradient-to-r from-[#C5A35C]/10 to-[#B8933D]/10 border-2 border-[#C5A35C]/20">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {t('faq.cta.title')}
          </h3>
          <p className="text-gray-600 mb-4">
            {t('faq.cta.description')}
          </p>
          <a 
            href="#contact"
            className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-[#C5A35C] text-white font-semibold hover:bg-[#B8933D] transition-colors"
          >
            {t('faq.cta.button')}
          </a>
        </div>
      </div>
    </section>
  );
};
